import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("h3", null, "Name", -1)
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h3", null, "Typ", -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("h3", null, "Startpunkt", -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("h3", null, "Endpunkt", -1)

import {onMounted, ref, computed, onUpdated} from "vue";
import {IonCard, IonCardHeader, IonCardTitle, IonCardContent, IonIcon, toastController} from "@ionic/vue";
import {MobiPointApiProfile, ResponseError} from "@/mobipoints/api/profile";
import {UserTrackingTemplate} from "@/mobipoints/profile/userTrackingTemplate/user_tracking_template.type";
import router from "@/router";
import * as icons from 'ionicons/icons';
import {AxiosError, AxiosResponse} from "axios";
import useProfileFactory from "@/composable/useProfileFactory";


export default /*#__PURE__*/_defineComponent({
  __name: 'UserTrackingTemplateDetail',
  props: {
  userTrackingTemplateId: {
    type: Number,
    required: true,
  }
},
  setup(__props, { expose: __expose }) {

const props = __props;

const {getProfileFactory} = useProfileFactory();

const userTrackingTemplate = ref<UserTrackingTemplate>(getProfileFactory().createEmptyUserTrackingTemplate());
const userTrackingTrackTypeIcon = computed(() => {
  return userTrackingTemplate.value.userTrackingTrackType && userTrackingTemplate.value.userTrackingTrackType.getTrackTypeIcon();
});

onMounted(() => {
  loadUserTrackingTemplate(props.userTrackingTemplateId).then((response) => {
    if (null === response) {
      router.back();
    }
  });
});


const refreshUserTrackingTemplateDetail = async function (): Promise<boolean> {
  return !!(await loadUserTrackingTemplate(props.userTrackingTemplateId));
}


const loadUserTrackingTemplate = async function (id: number) {
  let response: AxiosResponse | null = null;

  try {
    response = await MobiPointApiProfile.getUserTrackingTemplate(id);
    userTrackingTemplate.value = getProfileFactory().createUserTrackingTemplateListByApiResponse(response.data).shift() ?? userTrackingTemplate.value;
  } catch (error: any | AxiosError) {
    // TODO create a custom toast controller to handle this kind of toasts (display error and go back)
    const toast = await toastController.create({
      message: `Could not load user tracking template ${id}`,
      position: 'bottom',
      duration: 3000,
      icon: icons.warning,
      buttons: [
        {
          side: 'end',
          role: 'cancel',
          icon: icons.close
        }
      ]
    });
    // toast.onWillDismiss().then(router.back);
    await toast.present();

    return response;
  }
}

__expose({
  refreshUserTrackingTemplateDetail
});

return (_ctx: any,_cache: any) => {
  const _component_ion_text = _resolveComponent("ion-text")!
  const _component_ion_label = _resolveComponent("ion-label")!
  const _component_ion_item = _resolveComponent("ion-item")!

  return (_openBlock(), _createBlock(_unref(IonCard), null, {
    default: _withCtx(() => [
      _createVNode(_unref(IonCardHeader), null, {
        default: _withCtx(() => [
          _createVNode(_unref(IonCardTitle), null, {
            default: _withCtx(() => [
              _createTextVNode(" Tracking Vorlage Details ")
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_unref(IonCardContent), null, {
        default: _withCtx(() => [
          _createVNode(_component_ion_item, null, {
            default: _withCtx(() => [
              _createVNode(_unref(IonIcon), {
                slot: "start",
                icon: icons.pricetag
              }, null, 8, ["icon"]),
              _createVNode(_component_ion_label, { class: "ion-text-wrap" }, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_text, { color: "primary" }, {
                    default: _withCtx(() => [
                      _hoisted_1
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_ion_text, null, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(userTrackingTemplate.value.name), 1)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_ion_item, null, {
            default: _withCtx(() => [
              _createVNode(_unref(IonIcon), {
                slot: "start",
                icon: userTrackingTemplate.value.userTrackingTrackType && userTrackingTemplate.value.userTrackingTrackType.getTrackTypeIcon()
              }, null, 8, ["icon"]),
              _createVNode(_component_ion_label, { class: "ion-text-wrap" }, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_text, { color: "primary" }, {
                    default: _withCtx(() => [
                      _hoisted_2
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_ion_text, null, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(userTrackingTemplate.value.userTrackingTrackType && userTrackingTemplate.value.userTrackingTrackType.name), 1)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_ion_item, null, {
            default: _withCtx(() => [
              _createVNode(_unref(IonIcon), {
                slot: "start",
                icon: icons.pin
              }, null, 8, ["icon"]),
              _createVNode(_component_ion_label, { class: "ion-text-wrap" }, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_text, { color: "primary" }, {
                    default: _withCtx(() => [
                      _hoisted_3
                    ]),
                    _: 1
                  }),
                  (userTrackingTemplate.value.startLocation !== null && userTrackingTemplate.value.startLocation.id !== null)
                    ? (_openBlock(), _createBlock(_component_ion_text, { key: 0 }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(userTrackingTemplate.value.startLocation.getFormattedAddress()), 1)
                        ]),
                        _: 1
                      }))
                    : (_openBlock(), _createBlock(_component_ion_text, { key: 1 }, {
                        default: _withCtx(() => [
                          _createTextVNode("-")
                        ]),
                        _: 1
                      }))
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_ion_item, null, {
            default: _withCtx(() => [
              _createVNode(_unref(IonIcon), {
                slot: "start",
                icon: icons.pin
              }, null, 8, ["icon"]),
              _createVNode(_component_ion_label, { class: "ion-text-wrap" }, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_text, { color: "primary" }, {
                    default: _withCtx(() => [
                      _hoisted_4
                    ]),
                    _: 1
                  }),
                  (userTrackingTemplate.value.endLocation !== null && userTrackingTemplate.value.endLocation.id !== null)
                    ? (_openBlock(), _createBlock(_component_ion_text, { key: 0 }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(userTrackingTemplate.value.endLocation.getFormattedAddress()), 1)
                        ]),
                        _: 1
                      }))
                    : (_openBlock(), _createBlock(_component_ion_text, { key: 1 }, {
                        default: _withCtx(() => [
                          _createTextVNode("-")
                        ]),
                        _: 1
                      }))
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})